import {FmlxModal} from 'fmlx-common-ui';

import {ModalMode, ModalType, ModalVariant} from '@/constants/modalEnum';

import {Modal} from '../../constants/actionType';

const initialState = {
  show: false,
  type: ModalType.GENERIC,
  variant: ModalVariant.GENERIC,
  mode: ModalMode.DEFAULT,
  size: FmlxModal.Size.SM,
  inlineMessage: {
    type: '',
    message: '',
  },
  hideCloseButton: true,
  disableBlur: true,
  isMinimized: false,
  // todo: change modal pattern
  header: '',
  content: '',
  actions: [],
  actionClose: () => {},
};

export default function modalState(state = initialState, action = {}) {
  switch (action.type) {
    case Modal.SHOW:
      return {...state, ...action.modalState};
    case Modal.SHOW_GENERIC:
      return {
        ...state,
        show: true,
        type: ModalType.GENERIC,
        variant: ModalVariant.GENERIC,
        mode: ModalMode.DEFAULT,
        size: FmlxModal.Size.SM,
        header: action.header,
        content: action.content,
        actions: action.actions,
        actionClose: action.actionClose,
      };
    case Modal.SET_VARIANT:
      return {...state, variant: action.variant};
    case Modal.SET_MODE:
      return {...state, mode: action.mode};
    case Modal.SET_HIDE_CLOSE_BUTTON:
      return {...state, hideCloseButton: action.value};
    case Modal.SET_INLINE_MESSAGE:
      return {...state, inlineMessage: action.inlineMessage};
    case Modal.SET_CLOSE_ON_BLUR:
      return {...state, disableBlur: action.value};
    case Modal.SET_SIZE:
      return {...state, size: action.size};
    case Modal.SET_IS_MINIMIZED:
      return {...state, isMinimized: action.isMinimized};
    case Modal.HIDE:
      return initialState;
    default:
      return state;
  }
}
